module.exports = __webpack_public_path__ + "img/yellow-circle-table-4.9106d10f.png";